import EtablissementModeFacture from '@/generated/controls/etablissement/EtablissementModeFacture.vue';
import { defineComponent } from 'vue';
import Item from '@/framework/base/classes/Item';

export const ETABLISSEMENT_MODE_FACTURE_ITEMS: Item[] = [
  { "key": 1, "title": "Facture distincte pour chaque règlement" },
  { "key": 2, "title": "Facture globale pour tous les règlements" },
  { "key": 3, "title": "Facture regroupant les règlements par projet" }
];

export default defineComponent({
  components: {},
  extends: EtablissementModeFacture,

  data() {
    return { items: ETABLISSEMENT_MODE_FACTURE_ITEMS };
  }
})